import React from "react";

const FlowCircleInActive = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.71875 0.9375C3.52585 0.9375 0.9375 3.52585 0.9375 6.71875C0.9375 9.91165 3.52585 12.5 6.71875 12.5C9.91165 12.5 12.5 9.91165 12.5 6.71875C12.5 3.52585 9.91165 0.9375 6.71875 0.9375ZM0 6.71875C0 3.00809 3.00809 0 6.71875 0C10.4294 0 13.4375 3.00809 13.4375 6.71875C13.4375 10.4294 10.4294 13.4375 6.71875 13.4375C3.00809 13.4375 0 10.4294 0 6.71875Z"
        fill="#4E4E5D"
      />
    </svg>
  );
};

export default FlowCircleInActive;
